import { Html } from "@custom/schema";
import clsx from "clsx";
import React from "react";
var isEuropeanTimezone = function(timeZone) {
    var europeanTimeZones = [
        "Europe/",
        "Atlantic/Azores",
        "Atlantic/Canary",
        "Atlantic/Faroe",
        "Atlantic/Madeira",
        "Atlantic/Reykjavik",
        "WET"
    ];
    return europeanTimeZones.some(function(prefix) {
        return timeZone.startsWith(prefix);
    });
};
export default function PricingHeader(props) {
    var _props_knimeManaged, _props_knimeManaged1, _props_knimeManaged2, _props_knimeManaged3, _props_knimeManaged_cols, _props_customerManaged, _props_customerManaged1, _props_customerManaged2, _props_customerManaged_cols;
    var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var useEuro = isEuropeanTimezone(timeZone);
    var _item_buttonClass, _item_buttonClass1;
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx("relative overflow-hidden pt-12 pb-5 md:pt-20 lg:pt-28 md:pb-16 lg:pb-20 px-6 md:px-14 mb-10 bg-gradient-to-b from-white to-[#F7F9FB]", {})
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto max-w-7xl overflow-hidden md:px-2"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-center"
    }, /*#__PURE__*/ React.createElement("h1", {
        className: "text-center text-4xl leading-tight md:text-5xl lg:text-6xl mb-4 md:mb-7 font-heading font-semibold"
    }, props.heading), props.summary ? /*#__PURE__*/ React.createElement("div", {
        className: "max-w-4xl mx-auto text-gray-100 mb-10 md:mb-16 lg:mb-20 md:text-lg xl:text-xl black-links"
    }, /*#__PURE__*/ React.createElement(Html, {
        markup: props.summary
    })) : null), /*#__PURE__*/ React.createElement("div", {
        className: "1.5lg:flex 1.5lg:gap-x-7"
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("1.5lg:w-2/5 1.5lg:flex 1.5lg:flex-col", {
            "md:w-2/3 md:mx-auto 1.5lg:m-0": ((_props_knimeManaged = props.knimeManaged) === null || _props_knimeManaged === void 0 ? void 0 : _props_knimeManaged.cols) && props.knimeManaged.cols.length < 3
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-center mb-9 md:mb-12 relative pt-9"
    }, /*#__PURE__*/ React.createElement(BlueLineShort, null), /*#__PURE__*/ React.createElement("span", {
        className: "font-heading font-semibold tracking-widest text-blue-500 uppercase text-sm block mb-2"
    }, ((_props_knimeManaged1 = props.knimeManaged) === null || _props_knimeManaged1 === void 0 ? void 0 : _props_knimeManaged1.lead) ? props.knimeManaged.lead : "KNIME-Managed"), /*#__PURE__*/ React.createElement("h2", {
        className: "font-heading font-medium text-xl md:text-2xl"
    }, ((_props_knimeManaged2 = props.knimeManaged) === null || _props_knimeManaged2 === void 0 ? void 0 : _props_knimeManaged2.subheading) ? props.knimeManaged.subheading : "KNIME Community Hub")), /*#__PURE__*/ React.createElement("div", {
        className: "md:flex md:gap-x-6 md:h-full"
    }, (_props_knimeManaged3 = props.knimeManaged) === null || _props_knimeManaged3 === void 0 ? void 0 : (_props_knimeManaged_cols = _props_knimeManaged3.cols) === null || _props_knimeManaged_cols === void 0 ? void 0 : _props_knimeManaged_cols.map(function(item, key) {
        return item ? /*#__PURE__*/ React.createElement("div", {
            key: key,
            className: "border flex-1 flex flex-col bg-white mb-6 md:mb-0"
        }, /*#__PURE__*/ React.createElement(PricingCol, {
            title: item.title,
            summary: item.summary,
            subtitle: item.subtitle,
            includedHeading: item.includedHeading,
            includedList: item.includedList,
            link: item.link,
            type: "community",
            priceSubheading: item.priceSubheading,
            priceDollars: item.priceDollars,
            priceEuros: item.priceEuros,
            useEuro: useEuro,
            priceSubtext: item.priceSubtext,
            buttonClass: (_item_buttonClass = item === null || item === void 0 ? void 0 : item.buttonClass) !== null && _item_buttonClass !== void 0 ? _item_buttonClass : ""
        })) : null;
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "1.5lg:w-3/5 1.5lg:flex 1.5lg:flex-col mt-10 1.5lg:mt-0 overflow-hidden"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-center mb-9 md:mb-12 relative pt-9"
    }, /*#__PURE__*/ React.createElement(BlueLineLong, null), /*#__PURE__*/ React.createElement("span", {
        className: "font-heading font-semibold tracking-widest text-blue-500 uppercase text-sm block mb-2"
    }, ((_props_customerManaged = props.customerManaged) === null || _props_customerManaged === void 0 ? void 0 : _props_customerManaged.lead) ? props.customerManaged.lead : "Customer-Managed"), /*#__PURE__*/ React.createElement("h2", {
        className: "font-heading font-medium text-xl md:text-2xl"
    }, ((_props_customerManaged1 = props.customerManaged) === null || _props_customerManaged1 === void 0 ? void 0 : _props_customerManaged1.subheading) ? props.customerManaged.subheading : "KNIME Business Hub")), /*#__PURE__*/ React.createElement("div", {
        className: "md:flex md:gap-x-6 md:h-full"
    }, (_props_customerManaged2 = props.customerManaged) === null || _props_customerManaged2 === void 0 ? void 0 : (_props_customerManaged_cols = _props_customerManaged2.cols) === null || _props_customerManaged_cols === void 0 ? void 0 : _props_customerManaged_cols.map(function(item, key) {
        return item ? /*#__PURE__*/ React.createElement("div", {
            key: key,
            className: "border flex-1 flex flex-col bg-white mb-6 md:mb-0"
        }, /*#__PURE__*/ React.createElement(PricingCol, {
            title: item.title,
            summary: item.summary,
            subtitle: item.subtitle,
            includedHeading: item.includedHeading,
            includedList: item.includedList,
            link: item.link,
            type: "business",
            priceSubheading: item.priceSubheading,
            priceDollars: item.priceDollars,
            priceEuros: item.priceEuros,
            useEuro: useEuro,
            priceSubtext: item.priceSubtext,
            buttonClass: (_item_buttonClass1 = item === null || item === void 0 ? void 0 : item.buttonClass) !== null && _item_buttonClass1 !== void 0 ? _item_buttonClass1 : ""
        })) : null;
    }))))));
}
function PricingCol(param) {
    var title = param.title, summary = param.summary, subtitle = param.subtitle, includedHeading = param.includedHeading, includedList = param.includedList, link = param.link, type = param.type, priceSubheading = param.priceSubheading, priceDollars = param.priceDollars, priceEuros = param.priceEuros, priceSubtext = param.priceSubtext, buttonClass = param.buttonClass, useEuro = param.useEuro;
    var price = useEuro ? priceEuros !== undefined ? priceEuros : null : priceDollars !== undefined ? priceDollars : null;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: clsx("p-6 relative flex flex-col md:min-h-[270px] justify-between", {
            "bg-yellow-500": type === "business",
            "bg-yellow-100 md:min-h-[240px]": type === "community"
        })
    }, /*#__PURE__*/ React.createElement("div", null, type === "business" ? /*#__PURE__*/ React.createElement(LightDots, null) : /*#__PURE__*/ React.createElement(DarkDots, null), /*#__PURE__*/ React.createElement("h3", {
        className: "text-2xl md:text-3xl font-medium mb-1"
    }, title), /*#__PURE__*/ React.createElement("span", {
        className: clsx("block md:text-lg md:leading-tight", {
            "text-gray-200": type === "community"
        })
    }, summary), subtitle ? /*#__PURE__*/ React.createElement("span", {
        className: clsx("block text-xs relative", {
            "text-gray-200 mt-4": type === "community",
            "mt-1.5": type === "business"
        })
    }, subtitle) : null), /*#__PURE__*/ React.createElement("div", {
        className: "mt-4"
    }, priceSubheading ? /*#__PURE__*/ React.createElement("span", {
        className: clsx("block text-xs relative", {
            "text-gray-200": type === "community"
        })
    }, priceSubheading) : null, priceEuros || priceDollars ? /*#__PURE__*/ React.createElement("span", {
        className: "block text-2xl font-medium relative"
    }, price) : null, priceSubtext ? /*#__PURE__*/ React.createElement("span", {
        className: "block relative font-heading font-medium"
    }, priceSubtext) : null)), /*#__PURE__*/ React.createElement("div", {
        className: "p-6 md:flex md:flex-col md:justify-between md:h-full"
    }, /*#__PURE__*/ React.createElement("div", {
        className: ""
    }, /*#__PURE__*/ React.createElement("span", {
        className: "block font-heading font-medium mb-2"
    }, "What's included"), includedHeading ? /*#__PURE__*/ React.createElement("span", {
        className: "block text-sm font-heading font-medium mb-2"
    }, includedHeading) : null, /*#__PURE__*/ React.createElement("ul", {
        className: "text-sm"
    }, includedList && (includedList === null || includedList === void 0 ? void 0 : includedList.map(function(included, key) {
        return /*#__PURE__*/ React.createElement("li", {
            key: key,
            className: 'pl-5 mb-2.5 relative included-list white-tick before:content-[""] before:block before:h-3 before:w-3 before:bg-blue-500 before:absolute before:top-[3px] before:left-0'
        }, /*#__PURE__*/ React.createElement("div", {
            dangerouslySetInnerHTML: {
                __html: included
            }
        }));
    })))), /*#__PURE__*/ React.createElement("a", {
        href: link === null || link === void 0 ? void 0 : link.target,
        id: (link === null || link === void 0 ? void 0 : link.id) || "pricing-".concat(title.toLowerCase()),
        className: clsx(buttonClass + " mt-5 w-full sm:w-auto focus", {
            "button-secondary bg-white border-gray-600 text-gray-600 hover:bg-gray-600 hover:text-white": type === "community",
            "button-secondary border-gray-600 text-white bg-gray-600 hover:text-gray-600 hover:bg-white": type === "business"
        })
    }, link === null || link === void 0 ? void 0 : link.label)));
}
function BlueLineShort() {
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "521px",
        height: "100px",
        viewBox: "0 0 521 100",
        version: "1.1",
        className: "absolute top-0 left-0 knime-hidden xl:block"
    }, /*#__PURE__*/ React.createElement("title", null, "Angle Line/Lighter Blue"), /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Pricing-Page",
        transform: "translate(-74.000000, -417.000000)",
        stroke: "#D0ECEF",
        strokeWidth: "2"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Hero",
        transform: "translate(0.000000, 100.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Category-1",
        transform: "translate(75.000000, 318.000000)"
    }, /*#__PURE__*/ React.createElement("polyline", {
        id: "Angle-Line/Lighter-Blue",
        transform: "translate(260.000000, 49.500000) scale(1, -1) rotate(-90.000000) translate(-260.000000, -49.500000) ",
        points: "210.5 309.5 210.5 -149.16074 269.055013 -210.5 309.5 -210.5"
    })))))), /*#__PURE__*/ React.createElement("div", {
        className: "xl:hidden"
    }, /*#__PURE__*/ React.createElement(BlueLineLong, null)));
}
function BlueLineLong() {
    return /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "741px",
        height: "100px",
        viewBox: "0 0 741 100",
        version: "1.1",
        className: "absolute top-0 left-0 lg:w-full 1.5lg:w-auto"
    }, /*#__PURE__*/ React.createElement("title", null, "Angle Line/Light Blue"), /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Pricing-Page",
        transform: "translate(-624.000000, -417.000000)",
        stroke: "#9CD0DE",
        strokeWidth: "2"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Hero",
        transform: "translate(0.000000, 100.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Category-2",
        transform: "translate(625.000000, 318.000000)"
    }, /*#__PURE__*/ React.createElement("polyline", {
        id: "Angle-Line/Light-Blue",
        transform: "translate(370.000000, 49.500000) scale(1, -1) rotate(-90.000000) translate(-370.000000, -49.500000) ",
        points: "320.5 419.5 320.5 -259.253069 379.055013 -320.5 419.5 -320.5"
    }))))));
}
function DarkDots() {
    return /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "140px",
        height: "65px",
        viewBox: "0 0 140 65",
        version: "1.1",
        className: "absolute bottom-1.5 right-1"
    }, /*#__PURE__*/ React.createElement("title", null, "Bit Cluster/Corner/Yellow"), /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Pricing-Page",
        transform: "translate(-446.000000, -682.000000)",
        fill: "#FEEC80"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Hero",
        transform: "translate(0.000000, 100.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Plans/Community-Hub",
        transform: "translate(75.000000, 318.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Tile/Teams/Individuals",
        transform: "translate(275.000000, 147.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Bit-Cluster/Corner/Yellow",
        transform: "translate(166.000000, 187.000000) rotate(-360.000000) translate(-166.000000, -187.000000) translate(46.000000, 117.000000)"
    }, /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(158.000000, 58.000000) rotate(-180.000000) translate(-158.000000, -58.000000) ",
        x: "151",
        y: "51",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(158.000000, 32.000000) rotate(-180.000000) translate(-158.000000, -32.000000) ",
        x: "151",
        y: "25",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(158.000000, 7.000000) rotate(-180.000000) translate(-158.000000, -7.000000) ",
        x: "151",
        y: "1.42108547e-14",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(132.000000, 83.000000) rotate(-180.000000) translate(-132.000000, -83.000000) ",
        x: "125",
        y: "76",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(158.000000, 83.000000) rotate(-180.000000) translate(-158.000000, -83.000000) ",
        x: "151",
        y: "76",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(183.000000, 58.000000) rotate(-180.000000) translate(-183.000000, -58.000000) ",
        x: "176",
        y: "51",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(132.000000, 58.000000) rotate(-180.000000) translate(-132.000000, -58.000000) ",
        x: "125",
        y: "51",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(132.000000, 32.000000) rotate(-180.000000) translate(-132.000000, -32.000000) ",
        x: "125",
        y: "25",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(107.000000, 83.000000) rotate(-180.000000) translate(-107.000000, -83.000000) ",
        x: "100",
        y: "76",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(107.000000, 108.000000) rotate(-180.000000) translate(-107.000000, -108.000000) ",
        x: "100",
        y: "101",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(82.000000, 133.000000) rotate(-180.000000) translate(-82.000000, -133.000000) ",
        x: "75",
        y: "126",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(107.000000, 58.000000) rotate(-180.000000) translate(-107.000000, -58.000000) ",
        x: "100",
        y: "51",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(82.000000, 32.000000) rotate(-180.000000) translate(-82.000000, -32.000000) ",
        x: "75",
        y: "25",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(132.000000, 7.000000) rotate(-180.000000) translate(-132.000000, -7.000000) ",
        x: "125",
        y: "0",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(57.000000, 83.000000) rotate(-180.000000) translate(-57.000000, -83.000000) ",
        x: "50",
        y: "76",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(183.000000, 32.000000) rotate(-180.000000) translate(-183.000000, -32.000000) ",
        x: "176",
        y: "25",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(208.000000, 7.000000) rotate(-180.000000) translate(-208.000000, -7.000000) ",
        x: "201",
        y: "0",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(233.000000, 7.000000) rotate(-180.000000) translate(-233.000000, -7.000000) ",
        x: "226",
        y: "0",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(208.000000, 32.000000) rotate(-180.000000) translate(-208.000000, -32.000000) ",
        x: "201",
        y: "25",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(7.000000, 133.000000) rotate(-180.000000) translate(-7.000000, -133.000000) ",
        x: "3.1096125e-14",
        y: "126",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(57.000000, 58.000000) rotate(-180.000000) translate(-57.000000, -58.000000) ",
        x: "50",
        y: "51",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(32.000000, 108.000000) rotate(-180.000000) translate(-32.000000, -108.000000) ",
        x: "25",
        y: "101",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(57.000000, 133.000000) rotate(-180.000000) translate(-57.000000, -133.000000) ",
        x: "50",
        y: "126",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(57.000000, 108.000000) rotate(-180.000000) translate(-57.000000, -108.000000) ",
        x: "50",
        y: "101",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(82.000000, 83.000000) rotate(-180.000000) translate(-82.000000, -83.000000) ",
        x: "75",
        y: "76",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(82.000000, 108.000000) rotate(-180.000000) translate(-82.000000, -108.000000) ",
        x: "75",
        y: "101",
        width: "14",
        height: "14",
        rx: "7"
    }))))))));
}
function LightDots() {
    return /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "89px",
        height: "64px",
        viewBox: "0 0 89 64",
        version: "1.1",
        className: "absolute bottom-1.5 right-0"
    }, /*#__PURE__*/ React.createElement("title", null, "Bit Cluster/Corner/Yellow"), /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Pricing-Page",
        transform: "translate(-756.000000, -682.000000)",
        fill: "#FEEC80"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Hero",
        transform: "translate(0.000000, 100.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Plans/Business-Hub",
        transform: "translate(625.000000, 318.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Tile/Teams/Basic",
        transform: "translate(0.000000, 147.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Bit-Cluster/Corner/Yellow",
        transform: "translate(150.000000, 237.000000) scale(-1, 1) rotate(-270.000000) translate(-150.000000, -237.000000) translate(30.000000, 167.000000)"
    }, /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(158.000000, 58.000000) rotate(-180.000000) translate(-158.000000, -58.000000) ",
        x: "151",
        y: "51",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(158.000000, 32.000000) rotate(-180.000000) translate(-158.000000, -32.000000) ",
        x: "151",
        y: "25",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(158.000000, 7.000000) rotate(-180.000000) translate(-158.000000, -7.000000) ",
        x: "151",
        y: "7.61261754e-15",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(132.000000, 83.000000) rotate(-180.000000) translate(-132.000000, -83.000000) ",
        x: "125",
        y: "76",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(158.000000, 83.000000) rotate(-180.000000) translate(-158.000000, -83.000000) ",
        x: "151",
        y: "76",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(183.000000, 58.000000) rotate(-180.000000) translate(-183.000000, -58.000000) ",
        x: "176",
        y: "51",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(132.000000, 58.000000) rotate(-180.000000) translate(-132.000000, -58.000000) ",
        x: "125",
        y: "51",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(132.000000, 32.000000) rotate(-180.000000) translate(-132.000000, -32.000000) ",
        x: "125",
        y: "25",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(107.000000, 83.000000) rotate(-180.000000) translate(-107.000000, -83.000000) ",
        x: "100",
        y: "76",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(107.000000, 108.000000) rotate(-180.000000) translate(-107.000000, -108.000000) ",
        x: "100",
        y: "101",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(82.000000, 133.000000) rotate(-180.000000) translate(-82.000000, -133.000000) ",
        x: "75",
        y: "126",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(107.000000, 58.000000) rotate(-180.000000) translate(-107.000000, -58.000000) ",
        x: "100",
        y: "51",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(82.000000, 32.000000) rotate(-180.000000) translate(-82.000000, -32.000000) ",
        x: "75",
        y: "25",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(132.000000, 7.000000) rotate(-180.000000) translate(-132.000000, -7.000000) ",
        x: "125",
        y: "1.23887401e-14",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(57.000000, 83.000000) rotate(-180.000000) translate(-57.000000, -83.000000) ",
        x: "50",
        y: "76",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(183.000000, 32.000000) rotate(-180.000000) translate(-183.000000, -32.000000) ",
        x: "176",
        y: "25",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(208.000000, 7.000000) rotate(-180.000000) translate(-208.000000, -7.000000) ",
        x: "201",
        y: "1.26386213e-14",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(233.000000, 7.000000) rotate(-180.000000) translate(-233.000000, -7.000000) ",
        x: "226",
        y: "8.04619576e-15",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(208.000000, 32.000000) rotate(-180.000000) translate(-208.000000, -32.000000) ",
        x: "201",
        y: "25",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(7.000000, 133.000000) rotate(-180.000000) translate(-7.000000, -133.000000) ",
        x: "-2.84217094e-14",
        y: "126",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(57.000000, 58.000000) rotate(-180.000000) translate(-57.000000, -58.000000) ",
        x: "50",
        y: "51",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(32.000000, 108.000000) rotate(-180.000000) translate(-32.000000, -108.000000) ",
        x: "25",
        y: "101",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(57.000000, 133.000000) rotate(-180.000000) translate(-57.000000, -133.000000) ",
        x: "50",
        y: "126",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(57.000000, 108.000000) rotate(-180.000000) translate(-57.000000, -108.000000) ",
        x: "50",
        y: "101",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(82.000000, 83.000000) rotate(-180.000000) translate(-82.000000, -83.000000) ",
        x: "75",
        y: "76",
        width: "14",
        height: "14",
        rx: "7"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(82.000000, 108.000000) rotate(-180.000000) translate(-82.000000, -108.000000) ",
        x: "75",
        y: "101",
        width: "14",
        height: "14",
        rx: "7"
    }))))))));
}
